<template>
  <div style="margin-bottom: 200px;">
    <h1 v-bg-typography="'h1'" :style="{ marginTop: '10px' }">Suggestions</h1>

    <div class="searchbar">
      <bg-field
        class="search-input"
        label="Search"
        v-model="searchString"
        name="search"
      >
        <bg-input
          name="search"
          placeholder="Type something here.."
          v-model="searchString"
        />
      </bg-field>
      <BgButton
        text="New suggestion"
        @click="$router.push(`/test/${$route.params.id}/suggestions/new`)"
      />
    </div>
    <bg-loader :dark="true" v-if="isLoading"></bg-loader>
    <div v-if="!isLoading && suggestions.length === 0">
      <h3>There are currently none, so start adding them! &#128070;</h3>
    </div>
    <div v-if="!isLoading">
      <draggable
        group="all"
        :list="suggestions"
        :animation="200"
        @change="log"
        id="suggestions"
        ghost-class="ghost-card"
      >
        <Card
          v-for="suggestion in filtered"
          v-bind:key="suggestion.id"
          v-bind:suggestion="suggestion"
          @select="select(suggestion)"
        />
      </draggable>
    </div>
  </div>
</template>

<style scoped>
.searchbar {
  display: flex;
  align-items: center;
  max-width: 400px;
  gap: 20px;
}
.ghost-card {
  opacity: 0.5;
  background: #f7fafc;
  border: 1px solid #00deab;
}
</style>

<script>
import BgTypography from "@/directives/bg-typography";
import BgLoader from "@/components/bg-loader";
import API from "@/api";
import BgButton from "@/components/bg-button";
import BgField from "@/components/bg-field";
import BgInput from "@/components/bg-input";
import Card from "@/components/suggestion-card";
import { mapState } from "vuex";
import Draggable from "vuedraggable";

export default {
  components: {
    BgLoader,
    BgButton,
    BgField,
    BgInput,
    Card,
    Draggable,
  },
  directives: {
    BgTypography,
  },
  data() {
    return {
      isLoading: false,
      optionOwners: [],
      searchString: "",
      suggestions: [],
    };
  },
  computed: {
    ...mapState({
      usersState: (state) => state.users,
      testState: (state) => state.test,
    }),
    filtered() {
      let list = this.suggestions;

      list = list.filter(
        (el) =>
          el.title.toLowerCase().includes(this.searchString.toLowerCase()) ||
          el.suggestion.toLowerCase().includes(this.searchString.toLowerCase())
      );

      return list;
    },
  },
  methods: {
    async fetchData() {
      this.isLoading = true;
      const testId = this.$route.params.id;
      // Ensure test is present in store when landing directly on this route
      if (!this.testState || (this.testState && String(this.testState.id) !== String(testId))) {
        try {
          await this.$store.dispatch("fetchTest", testId);
        } catch (e) {
          // continue; suggestions can still load
        }
      }

      const suggestions = await API.test.getSuggestions(testId);

      function compare(a, b) {
        // Use toUpperCase() to ignore character casing
        const brandA = a.rank;
        const brandB = b.rank;

        let comparison = 0;
        if (brandA > brandB) {
          comparison = 1;
        } else if (brandA < brandB) {
          comparison = -1;
        }
        return comparison;
      }
      suggestions.suggestions.sort(compare);
      let rank = 0;
      let changes = false;
      suggestions.suggestions.forEach((el) => {
        if (el.rank != rank + 1) {
          el.rank = rank + 1;
          changes = true;
        }
        rank = rank + 1;
      });

      suggestions.suggestions.forEach(async (s) => {
        if (s.owner_id) {
          try {
            const owner = await API.user.getUser(s.owner_id);
            s.owner = owner && owner.profile ? owner.profile.first_name : "";
          } catch (e) {
            s.owner = "";
          }
        } else {
          s.owner = "";
        }
      });

      if (changes) {
        suggestions.suggestions.forEach(async (el) => {
          await API.test.updateSuggestion(el);
        });
      }

      this.suggestions = suggestions.suggestions;
      this.isLoadingUsers = true;
      try {
        if (this.testState && this.testState.company) {
          const users = await API.user.getCompanyUsers(this.testState.company.id);
          this.optionOwners = users.users;
        } else {
          this.optionOwners = [];
        }
      } catch (e) {
        this.optionOwners = [];
      }
      this.isLoadingUsers = false;
      this.isLoading = false;
    },
    log() {
      let rank = 1;
      this.suggestions.forEach((el) => {
        el.rank = rank;
        API.test.updateSuggestion(el);
        rank = rank + 1;
      });
    },
    select(suggestion) {
      this.$router.push(
        `/test/${this.$route.params.id}/suggestions/${suggestion.id}`
      );
    },
  },
  async mounted() {
    this.fetchData();
  },
};
</script>
